/**
 * useFollowUpCounts — one-shot counts loader for the AdminSidebar badge.
 * Fetches `/leads/follow-ups?bucket=overdue` once at mount: `counts`
 * always includes all four buckets regardless of the `bucket` filter, so
 * a single small round-trip is enough to render the badge without
 * pulling every follow-up item.
 *
 * Silent on failure: the sidebar must never block or show an error just
 * because the counts aren't available. `counts` stays null in that case
 * and the caller renders the entry without a badge.
 */
import { useCallback, useEffect, useState } from "react";
import { listFollowUps } from "@/lib/followUpsApi";

export function useFollowUpCounts({ enabled = true } = {}) {
  const [counts, setCounts] = useState(null);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    listFollowUps({ bucket: "overdue" })
      .then((res) => {
        if (!cancelled) setCounts(res.counts || null);
      })
      .catch(() => {
        if (!cancelled) setCounts(null);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled, version]);

  const reload = useCallback(() => setVersion((v) => v + 1), []);
  return { counts, reload };
}
